import { useCallback } from 'react';

import { formatTimeInput, normalizeTimeInput } from '../utils';

import type { ChangeEvent, FocusEvent } from 'react';

interface UseTimeInputParams {
  value?: string;
  onChange?(value: string): void;
  onBlur?(event: FocusEvent<HTMLInputElement>): void;
}

export const useTimeInput = ({
  value,
  onChange,
  onBlur,
}: UseTimeInputParams) => {
  const handleChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      onChange?.(formatTimeInput(target.value));
    },
    [onChange]
  );

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      const normalizedValue = normalizeTimeInput(value ?? '');

      if (normalizedValue !== value) {
        onChange?.(normalizedValue);
      }

      onBlur?.(event);
    },
    [onBlur, onChange, value]
  );

  return { handleChange, handleBlur };
};
